import type { RefOrGetter } from "ls/common/types";
import { useQuery } from "@tanstack/vue-query";
import { computed, toValue } from "vue";
import { queries } from "./queries";

export function useSeatsAndLicensesInfo(organizationId: RefOrGetter<string>) {
  const options = computed(() => {
    return {
      ...queries.seatsAndLicensesInfo(toValue(organizationId)),
    };
  });

  const query = useQuery(options);

  const seatsAndLicensesInfo = computed(() => query.data.value);

  const rpPublisherSeatsTotal = computed(() => {
    if (!seatsAndLicensesInfo.value) return 0;

    return seatsAndLicensesInfo.value.RpPublisherSeatsTotal;
  });

  const rpPublisherUsersWithSeatCount = computed(() => {
    if (!seatsAndLicensesInfo.value) return 0;

    return seatsAndLicensesInfo.value.RpPublisherUsersWithSeatCount;
  });

  const rpPublisherUsersWithoutSeatOrLicenseCount = computed(() => {
    if (!seatsAndLicensesInfo.value) return 0;

    return seatsAndLicensesInfo.value.RpPublisherUsersWithoutSeatOrLicenseCount;
  });

  const cloudAuthorSeatsTotal = computed(() =>
    seatsAndLicensesInfo.value?.CloudAuthorSeatsTotal ?? 0,
  );

  const cloudAuthorUsersWithSeatCount = computed(() =>
    seatsAndLicensesInfo.value?.CloudAuthorUsersWithSeatCount ?? 0,
  );

  const cloudAuthorUsersWithoutSeatCount = computed(() =>
    seatsAndLicensesInfo.value?.CloudAuthorUsersWithoutSeatCount ?? 0,
  );

  const isCloudSeatLimitReached = computed(() =>
    !!cloudAuthorUsersWithSeatCount.value
    && !!cloudAuthorSeatsTotal.value
    && cloudAuthorUsersWithSeatCount.value >= cloudAuthorSeatsTotal.value,
  );

  return {
    isPending: query.isPending,
    cloudAuthorSeatsTotal,
    cloudAuthorUsersWithSeatCount,
    cloudAuthorUsersWithoutSeatCount,
    isCloudSeatLimitReached,
    rpPublisherSeatsTotal,
    rpPublisherUsersWithSeatCount,
    rpPublisherUsersWithoutSeatOrLicenseCount,
  };
}
